var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-box" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.invoiceInfo,
            border: "",
            size: "mini",
            "max-height": "400px",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "开票状态",
              align: "center",
              prop: "invoiceStatus",
              fixed: "left",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.invoiceStatus,
                          placement: "top",
                          disabled: !scope.row.invoiceStatus,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.invoiceStatus
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.invoiceStatus) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "发票类型",
              align: "center",
              prop: "invoiceType",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.invoiceType,
                          placement: "top",
                          disabled: !scope.row.invoiceType,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.invoiceType
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.invoiceType) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "发票号码",
              align: "center",
              prop: "invoiceNumber",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.invoiceNumber,
                          placement: "top",
                          disabled: !scope.row.invoiceNumber,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.invoiceNumber
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.invoiceNumber) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "发票代码",
              align: "center",
              prop: "invoiceCode",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.invoiceCode,
                          placement: "top",
                          disabled: !scope.row.invoiceCode,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.invoiceCode
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.invoiceCode) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "发票抬头",
              align: "center",
              prop: "invoiceTitle",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.invoiceTitle,
                          placement: "top",
                          disabled: !scope.row.invoiceTitle,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.invoiceTitle
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.invoiceTitle) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "税号", align: "center", prop: "taxNumber" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.taxNumber,
                          placement: "top",
                          disabled: !scope.row.taxNumber,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(scope.row.taxNumber)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.taxNumber) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "金额", align: "center", prop: "amount" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.amount,
                          placement: "top",
                          disabled: !scope.row.amount,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(scope.row.amount)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.amount) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "备注", align: "center", prop: "remark" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.remark,
                          placement: "top",
                          disabled: !scope.row.remark,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(scope.row.remark)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.remark) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "邮箱/手机号",
              align: "center",
              prop: "emailAndPhoneNumber",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.emailAndPhoneNumber,
                          placement: "top",
                          disabled: !scope.row.emailAndPhoneNumber,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.emailAndPhoneNumber
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.emailAndPhoneNumber) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "座位号", align: "center", prop: "seatNumber" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.seatNumber,
                          placement: "top",
                          disabled: !scope.row.seatNumber,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(scope.row.seatNumber)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.seatNumber) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "反馈信息", align: "center", prop: "feedbackInfo" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.feedbackInfo,
                          placement: "top",
                          disabled: !scope.row.feedbackInfo,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(
                                  scope.row.feedbackInfo
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.feedbackInfo) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "申请时间", align: "center", prop: "applyTime" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.applyTime,
                          placement: "top",
                          disabled: !scope.row.applyTime,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-ellipsis-2 copyable",
                            on: {
                              click: function ($event) {
                                return _vm.copyToClipboard(scope.row.applyTime)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.applyTime) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              align: "center",
              fixed: "right",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isRedHandle &
                              (scope.row.state === 1) &
                              (scope.row.serialNo === _vm.currentSerialNo),
                            expression:
                              "\n            isRedHandle & (scope.row.state === 1) & (scope.row.serialNo === currentSerialNo)\n          ",
                          },
                        ],
                      },
                      [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v("红冲中~"),
                        ]),
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              (scope.row.state === 1) &
                              (_vm.isRedHandle === false),
                            expression:
                              "(scope.row.state === 1) & (isRedHandle === false)",
                          },
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["order_intercity_offset"],
                            expression: "['order_intercity_offset']",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleResetRed(scope.row.serialNo)
                          },
                        },
                      },
                      [_vm._v("\n          红冲\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.invoiceUrl,
                            expression: "scope.row.invoiceUrl",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.previewInvoice(scope.row.invoiceUrl)
                          },
                        },
                      },
                      [_vm._v("\n          预览发票\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.state === 1,
                            expression: "scope.row.state === 1",
                          },
                        ],
                        attrs: {
                          type: "text",
                          size: "small",
                          loading: _vm.itineraryLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getInvoiceItinerary(scope.row.serialNo)
                          },
                        },
                      },
                      [_vm._v("\n          预览行程单\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.state === 1,
                            expression: "scope.row.state === 1",
                          },
                        ],
                        attrs: {
                          type: "text",
                          size: "small",
                          loading: _vm.sendLoading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSendInvoice(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          重发邮件\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "has-permi",
                            rawName: "v-has-permi",
                            value: ["order_invoice_confirm"],
                            expression: "['order_invoice_confirm']",
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              scope.row.emailInvoiceFlag &&
                              scope.row.invoiceTypeCode === 1,
                            expression:
                              "scope.row.emailInvoiceFlag && scope.row.invoiceTypeCode === 1",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmAction(scope.row, 1)
                          },
                        },
                      },
                      [_vm._v("\n          开票确认\n        ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              scope.row.emailInvoiceFlag &&
                              scope.row.invoiceTypeCode === 2,
                            expression:
                              "scope.row.emailInvoiceFlag && scope.row.invoiceTypeCode === 2",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.confirmAction(scope.row, 2)
                          },
                        },
                      },
                      [_vm._v("\n          红冲确认\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "行程单",
            visible: _vm.itineraryShow,
            "append-to-body": true,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.itineraryShow = $event
            },
            close: _vm.close,
          },
        },
        [
          _vm.itineraryShow
            ? _c("InvoiceItinerary", { attrs: { item: _vm.itineraryInfo } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重新发送发票、行程单",
            "close-on-click-modal": false,
            visible: _vm.sendShow,
            "append-to-body": true,
            width: "35%",
            center: "",
          },
          on: { close: _vm.closeSend },
        },
        [
          _c(
            "div",
            { staticClass: "flex-col flex-center" },
            [
              _c("div", { staticClass: "margin-bottom-10" }, [
                _vm._v("请填写乘客手机号或电子邮箱，手机号无法发送行程单"),
              ]),
              _c(
                "el-form",
                {
                  ref: "modifyFormRef",
                  attrs: {
                    "label-position": "right",
                    model: _vm.form,
                    "label-width": "auto",
                    size: "mini",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收信方式：", prop: "type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { input: _vm.typeChange },
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("邮箱"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("手机号"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.form.type === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "是否发送行程单：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.isSendItinerary,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isSendItinerary", $$v)
                                },
                                expression: "form.isSendItinerary",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v("发送"),
                              ]),
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v("不发送"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.type === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "邮箱：", prop: "userEmail" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: { type: "text", placeholder: "请输入邮箱" },
                            model: {
                              value: _vm.form.userEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "userEmail",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.userEmail",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "el-form-item",
                        { attrs: { label: "手机号：", prop: "phone" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "250px" },
                            attrs: {
                              type: "text",
                              placeholder: "请输入手机号",
                            },
                            model: {
                              value: _vm.form.phone,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "phone",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.phone",
                            },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: { click: _vm.closeSend },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.sendLoading,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("\n        提 交\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("InvoiceAction", {
        ref: "invoiceAction",
        on: {
          refresh: function ($event) {
            return _vm.$emit("refresh")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }